import packageInfo from '../../../package.json';

export class versionHelper {
    static getVersionNumer(): string {
        return packageInfo.version;
    }
}